import React from 'react';
import { Input, Checkbox } from '../../../common/components/formControls';
import { Form, Panel, Row, Col } from 'react-bootstrap';
import { Field } from 'redux-form';
import withResourcesNamespace from '../../../common/components/withResourcesNamespace';


const HemisphericAnalysis = ({ t }) => {
	const colSize = { labelCol: 1, valueCol: 11 };
	const totalColSize = { labelCol: 6, valueCol: 4 };
	const singleTotalColSize = { labelCol: 3, valueCol: 2 };

	const descriptionStyle = {
		marginBottom: '10px'
	};

	const rightBrainMotorFields = [...Array(9).keys()]
		.map(x => <Field name={`rightBrainMotor_${x + 1}`} component={Checkbox} horizontal label={t(`RightBrainMotor_${x + 1}`)} disabled {...colSize} />);

	const leftBrainMotorFields = [...Array(12).keys()]
		.map(x => <Field name={`leftBrainMotor_${x + 1}`} component={Checkbox} horizontal label={t(`LeftBrainMotor_${x + 1}`)} disabled {...colSize} />);

	const rightBrainSensoryFields = [...Array(16).keys()]
		.map(x => <Field name={`rightBrainSensory_${x + 1}`} component={Checkbox} horizontal label={t(`RightBrainSensory_${x + 1}`)} disabled {...colSize} />);

	const leftBrainSensoryFields = [...Array(12).keys()]
		.map(x => <Field name={`leftBrainSensory_${x + 1}`} component={Checkbox} horizontal label={t(`LeftBrainSensory_${x + 1}`)} disabled {...colSize} />);

	const rightBrainEmotionalFields = [...Array(10).keys()]
		.map(x => <Field name={`rightBrainEmotional_${x + 1}`} component={Checkbox} horizontal label={t(`RightBrainEmotional_${x + 1}`)} disabled {...colSize} />);

	const leftBrainEmotionalFields = [...Array(13).keys()]
		.map(x => <Field name={`leftBrainEmotional_${x + 1}`} component={Checkbox} horizontal label={t(`LeftBrainEmotional_${x + 1}`)} disabled {...colSize} />);

	const rightBrainBehavioralFields = [...Array(23).keys()]
		.map(x => <Field name={`rightBrainBehavioral_${x + 1}`} component={Checkbox} horizontal label={t(`RightBrainBehavioral_${x + 1}`)} disabled {...colSize} />);

	const leftBrainBehavioralFields = [...Array(16).keys()]
		.map(x => <Field name={`leftBrainBehavioral_${x + 1}`} component={Checkbox} horizontal label={t(`LeftBrainBehavioral_${x + 1}`)} disabled {...colSize} />);

	const rightBrainAcademicFields = [...Array(28).keys()]
		.map(x => <Field name={`rightBrainAcademic_${x + 1}`} component={Checkbox} horizontal label={t(`RightBrainAcademic_${x + 1}`)} disabled {...colSize} />);

	const leftBrainAcademicFields = [...Array(36).keys()]
		.map(x => <Field name={`leftBrainAcademic_${x + 1}`} component={Checkbox} horizontal label={t(`LeftBrainAcademic_${x + 1}`)} disabled {...colSize} />);

	const rightBrainImmuneFields = [...Array(6).keys()]
		.map(x => <Field name={`rightBrainImmune_${x + 1}`} component={Checkbox} horizontal label={t(`RightBrainImmune_${x + 1}`)} disabled {...colSize} />);

	const leftBrainImmuneFields = [...Array(6).keys()]
		.map(x => <Field name={`leftBrainImmune_${x + 1}`} component={Checkbox} horizontal label={t(`LeftBrainImmune_${x + 1}`)} disabled {...colSize} />);

	const rightBrainAutonomicFields = [...Array(6).keys()]
		.map(x => <Field name={`rightBrainAutonomic_${x + 1}`} component={Checkbox} horizontal label={t(`RightBrainAutonomic_${x + 1}`)} disabled {...colSize} />);

	const leftBrainAutonomicFields = [...Array(2).keys()]
		.map(x => <Field name={`leftBrainAutonomic_${x + 1}`} component={Checkbox} horizontal label={t(`LeftBrainAutonomic_${x + 1}`)} disabled {...colSize} />);

	return (
		<Form >
			<div style={descriptionStyle}>{t('Description1')}</div>
			<div style={descriptionStyle}>{t('Description2')}</div>
			<Panel>
				<Panel.Heading>{t('RightBrainMotor')}</Panel.Heading>
				<Panel.Body>
					{rightBrainMotorFields}
					<Field name='rightBrainMotorTotalNumberOfChecks' component={Input} horizontal type='text' label={t('TotalNumberOfChecks')} {...singleTotalColSize} disabled />
				</Panel.Body>
			</Panel>
			<Panel>
				<Panel.Heading>{t('LeftBrainMotor')}</Panel.Heading>
				<Panel.Body>
					{leftBrainMotorFields}
					<Row>
						<Col sm={6}>
							<Field name='leftBrainMotorTotalNumberOfChecks' component={Input} horizontal type='text' label={t('TotalNumberOfChecks')} {...totalColSize} disabled />
						</Col>
					</Row>
					<Row>
						<Col sm={6}>
							<Field name='rightBrainMotorTotalNumberOfChecks' component={Input} horizontal type='text' label={t('TotalRightBrainChecks')} {...totalColSize} disabled />
						</Col>
						<Col sm={6}>
							<Field name='leftBrainMotorTotalNumberOfChecks' component={Input} horizontal type='text' label={t('TotalLeftBrainChecks')} {...totalColSize} disabled />
						</Col>
					</Row>
				</Panel.Body>
			</Panel>
			<Panel>
				<Panel.Heading>{t('RightBrainSensory')}</Panel.Heading>
				<Panel.Body>
					{rightBrainSensoryFields}
					<Field name='rightBrainSensoryTotalNumberOfChecks' component={Input} horizontal type='text' label={t('TotalNumberOfChecks')} {...singleTotalColSize} disabled />
				</Panel.Body>
			</Panel>
			<Panel>
				<Panel.Heading>{t('LeftBrainSensory')}</Panel.Heading>
				<Panel.Body>
					{leftBrainSensoryFields}
					<Row>
						<Col sm={6}>
							<Field name='leftBrainSensoryTotalNumberOfChecks' component={Input} horizontal type='text' label={t('TotalNumberOfChecks')} {...totalColSize} disabled />
						</Col>
					</Row>
					<Row>
						<Col sm={6}>
							<Field name='rightBrainSensoryTotalNumberOfChecks' component={Input} horizontal type='text' label={t('TotalRightBrainChecks')} {...totalColSize} disabled />
						</Col>
						<Col sm={6}>
							<Field name='leftBrainSensoryTotalNumberOfChecks' component={Input} horizontal type='text' label={t('TotalLeftBrainChecks')} {...totalColSize} disabled />
						</Col>
					</Row>
				</Panel.Body>
			</Panel>
			<Panel>
				<Panel.Heading>{t('RightBrainEmotional')}</Panel.Heading>
				<Panel.Body>
					{rightBrainEmotionalFields}
					<Field name='rightBrainEmotionalTotalNumberOfChecks' component={Input} horizontal type='text' label={t('TotalNumberOfChecks')} {...singleTotalColSize} disabled />
				</Panel.Body>
			</Panel>
			<Panel>
				<Panel.Heading>{t('LeftBrainEmotional')}</Panel.Heading>
				<Panel.Body>
					{leftBrainEmotionalFields}
					<Row>
						<Col sm={6}>
							<Field name='leftBrainEmotionalTotalNumberOfChecks' component={Input} horizontal type='text' label={t('TotalNumberOfChecks')} {...totalColSize} disabled />
						</Col>
					</Row>
					<Row>
						<Col sm={6}>
							<Field name='rightBrainEmotionalTotalNumberOfChecks' component={Input} horizontal type='text' label={t('TotalRightBrainChecks')} {...totalColSize} disabled />
						</Col>
						<Col sm={6}>
							<Field name='leftBrainEmotionalTotalNumberOfChecks' component={Input} horizontal type='text' label={t('TotalLeftBrainChecks')} {...totalColSize} disabled />
						</Col>
					</Row>
				</Panel.Body>
			</Panel>
			<Panel>
				<Panel.Heading>{t('RightBrainBehavioral')}</Panel.Heading>
				<Panel.Body>
					{rightBrainBehavioralFields}
					<Field name='rightBrainBehavioralTotalNumberOfChecks' component={Input} horizontal type='text' label={t('TotalNumberOfChecks')} {...singleTotalColSize} disabled />
				</Panel.Body>
			</Panel>
			<Panel>
				<Panel.Heading>{t('LeftBrainBehavioral')}</Panel.Heading>
				<Panel.Body>
					{leftBrainBehavioralFields}
					<Row>
						<Col sm={6}>
							<Field name='leftBrainBehavioralTotalNumberOfChecks' component={Input} horizontal type='text' label={t('TotalNumberOfChecks')} {...totalColSize} disabled />
						</Col>
					</Row>
					<Row>
						<Col sm={6}>
							<Field name='rightBrainBehavioralTotalNumberOfChecks' component={Input} horizontal type='text' label={t('TotalRightBrainChecks')} {...totalColSize} disabled />
						</Col>
						<Col sm={6}>
							<Field name='leftBrainBehavioralTotalNumberOfChecks' component={Input} horizontal type='text' label={t('TotalLeftBrainChecks')} {...totalColSize} disabled />
						</Col>
					</Row>
				</Panel.Body>
			</Panel>
			<Panel>
				<Panel.Heading style={{ height: 65 }}>
					{t('RightBrainAcademic')}
					<div style={descriptionStyle}>{t('RightBrainAcademicDescription')}</div>
				</Panel.Heading>
				<Panel.Body>
					{rightBrainAcademicFields}
					<Field name='rightBrainAcademicTotalNumberOfChecks' component={Input} horizontal type='text' label={t('TotalNumberOfChecks')} {...singleTotalColSize} disabled />
				</Panel.Body>
			</Panel>
			<Panel>
				<Panel.Heading style={{ height: 65 }}>
					{t('LeftBrainAcademic')}
					<div style={descriptionStyle}>{t('LeftBrainAcademicDescription')}</div>
				</Panel.Heading>
				<Panel.Body>
					{leftBrainAcademicFields}
					<Row>
						<Col sm={6}>
							<Field name='leftBrainAcademicTotalNumberOfChecks' component={Input} horizontal type='text' label={t('TotalNumberOfChecks')} {...totalColSize} disabled />
						</Col>
					</Row>
					<Row>
						<Col sm={6}>
							<Field name='rightBrainAcademicTotalNumberOfChecks' component={Input} horizontal type='text' label={t('TotalRightBrainChecks')} {...totalColSize} disabled />
						</Col>
						<Col sm={6}>
							<Field name='leftBrainAcademicTotalNumberOfChecks' component={Input} horizontal type='text' label={t('TotalLeftBrainChecks')} {...totalColSize} disabled />
						</Col>
					</Row>
				</Panel.Body>
			</Panel>
			<Panel>
				<Panel.Heading>{t('RightBrainImmune')}</Panel.Heading>
				<Panel.Body>
					{rightBrainImmuneFields}
					<Field name='rightBrainImmuneTotalNumberOfChecks' component={Input} horizontal type='text' label={t('TotalNumberOfChecks')} {...singleTotalColSize} disabled />
				</Panel.Body>
			</Panel>
			<Panel>
				<Panel.Heading>{t('LeftBrainImmune')}</Panel.Heading>
				<Panel.Body>
					{leftBrainImmuneFields}
					<Row>
						<Col sm={6}>
							<Field name='leftBrainImmuneTotalNumberOfChecks' component={Input} horizontal type='text' label={t('TotalNumberOfChecks')} {...totalColSize} disabled />
						</Col>
					</Row>
					<Row>
						<Col sm={6}>
							<Field name='rightBrainImmuneTotalNumberOfChecks' component={Input} horizontal type='text' label={t('TotalRightBrainChecks')} {...totalColSize} disabled />
						</Col>
						<Col sm={6}>
							<Field name='leftBrainImmuneTotalNumberOfChecks' component={Input} horizontal type='text' label={t('TotalLeftBrainChecks')} {...totalColSize} disabled />
						</Col>
					</Row>
				</Panel.Body>
			</Panel>
			<Panel>
				<Panel.Heading>{t('RightBrainAutonomic')}</Panel.Heading>
				<Panel.Body>
					{rightBrainAutonomicFields}
					<Field name='rightBrainAutonomicTotalNumberOfChecks' component={Input} horizontal type='text' label={t('TotalNumberOfChecks')} {...singleTotalColSize} disabled />
				</Panel.Body>
			</Panel>
			<Panel>
				<Panel.Heading>{t('LeftBrainAutonomic')}</Panel.Heading>
				<Panel.Body>
					{leftBrainAutonomicFields}
					<Row>
						<Col sm={6}>
							<Field name='leftBrainAutonomicTotalNumberOfChecks' component={Input} horizontal type='text' label={t('TotalNumberOfChecks')} {...totalColSize} disabled />
						</Col>
					</Row>
					<Row>
						<Col sm={6}>
							<Field name='rightBrainAutonomicTotalNumberOfChecks' component={Input} horizontal type='text' label={t('TotalRightBrainChecks')} {...totalColSize} disabled />
						</Col>
						<Col sm={6}>
							<Field name='leftBrainAutonomicTotalNumberOfChecks' component={Input} horizontal type='text' label={t('TotalLeftBrainChecks')} {...totalColSize} disabled />
						</Col>
					</Row>
				</Panel.Body>
			</Panel>
			<Panel>
				<Panel.Heading>{t('TotalAll')}</Panel.Heading>
				<Panel.Body>
					<Field name='totalAllRightBrainChecks' component={Input} horizontal type='text' label={t('TotalAllRightBrainChecks')} labelCol={5} valueCol={2} disabled />
					<Field name='totalAllLeftBrainChecks' component={Input} horizontal type='text' label={t('TotalAllLeftBrainChecks')} labelCol={5} valueCol={2} disabled />
					<Field name='rightOrLeft' component={Input} horizontal type='text' label={t('RightOrLeft')} labelCol={5} valueCol={2} disabled />
				</Panel.Body>
			</Panel>
		</Form>
	);
};

export default withResourcesNamespace(props => props.resourcesNamespace)(HemisphericAnalysis);